export const PaymentConst = {
  MAX_DESCRIPTION_LENGTH: 20,
  MAX_PAYMENT_MESSAGE_LENGTH: 300,

  PAYEASY_PAYMENT_BY_ATM_CASH_MAX_AMOUNT: 100_000,
  PAYEASY_PAYMENT_BY_ATM_MAX_AMOUNT: 999_999,
};
